export const BUILD_INFO = { sha: 'e4712e8' };
